import { ACCESS_LEVELS } from "../../constants/ticketConstants";

export const getSeverityStyle = (severity) => {
  const normalized = String(severity || "")
    .trim()
    .toLowerCase();
  const numericRank = parseInt(String(severity).replace(/[^0-9]/g, ""), 10);

  if (numericRank <= 1 || /critical|sev\s*1|urgent/.test(normalized)) {
    return { backgroundColor: "#FDECEC", color: "#C62828" };
  }
  if (numericRank === 2 || /high|sev\s*2|major/.test(normalized)) {
    return { backgroundColor: "#FFF4E5", color: "#B35B00" };
  }
  if (numericRank === 3 || /medium|sev\s*3|moderate/.test(normalized)) {
    return { backgroundColor: "#FFF8D6", color: "#8A6D00" };
  }
  if (numericRank >= 4 || /low|sev\s*4|minor/.test(normalized)) {
    return { backgroundColor: "#EAF7EA", color: "#1F7A1F" };
  }

  return { backgroundColor: "#F5F5F5", color: "#2B2B2B" };
};

export const getUserAccess = (persona, bauRole) => {
  const normalizedPersona = persona?.toLowerCase();
  // COE Users
  if (
    normalizedPersona === "central team (coe)" ||
    normalizedPersona === "digital coe"
  ) {
    return ACCESS_LEVELS.COE_ACCESS;
  }

  // EY Team Users
  if (normalizedPersona === "ey team") {
    switch (bauRole) {
      case "Service Governance and Reporting Manager":
      case "BAU Delivery Manager":
        return ACCESS_LEVELS.FULL_ACCESS;

      case "Frontend/API Developer":
        return ACCESS_LEVELS.DEV_RCA_ONLY;
      case "Data Engineer":
        return ACCESS_LEVELS.DEV_RCA_ONLY;
      case "Backend Developer":
        return ACCESS_LEVELS.DEV_RCA_ONLY;
      case "Functional SME":
        return ACCESS_LEVELS.DEV_RCA_ONLY;
      case "Data SME":
        return ACCESS_LEVELS.DEV_RCA_ONLY;

      default:
        return ACCESS_LEVELS.NO_ACCESS;
    }
  }

  return ACCESS_LEVELS.NO_ACCESS;
};
